import { authHeaders, betterFetch, CCS_URL } from './helper';

/**
 * fetch active canvas contracts from config service
 *
 * @returns {Promise<object>} active contract data
 */
export const getContracts = async function getActiveContracts() {
  const headers = authHeaders();
  const url = `${CCS_URL}/config/getActive`;
  return betterFetch(url, { headers });
};
